import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";

export const useSystem = () => {

    const Logs = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/system/logs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }, []);



    return {Logs};
}